const ZIP_REGEX = /^(\d{5}(\-\d{4})?)$/;
const CA_ZIP_REGEX = /^\D\d\D(\-| |)?\d\D\d$/i;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const PHONE_REPLACE = /\(|\)|\-|\_| /g;
const CVV_REGEX = [/^\d{3}$/, /^\d{4}$/];
const NON_DIGIT_REGEX = /\D/g;
const MM_YY_REGEX = /^(\d{2})\/(\d{2})$/;

export { ZIP_REGEX, CA_ZIP_REGEX, EMAIL_REGEX, PHONE_REPLACE, CVV_REGEX, NON_DIGIT_REGEX, MM_YY_REGEX };
